module.exports = __webpack_public_path__ + "static/p11-87d0ad5bc9345024418d0e158007480a.jpg";